// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CKi5","newExpiryDate":"styles_newExpiryDate__1OJO0","footer":"styles_footer__3Hqtg"};